export const MIN_SEARCH_RESULTS_FOLLOW = 3;